import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-6 md:mb-8">
          <p className="text-xs text-foreground-500 font-medium uppercase tracking-wider">漫画分类</p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
            发现你喜欢的类型
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg">
            从甜蜜恋爱到热血战斗，从烧脑悬疑到温暖日常，总有一类适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group block p-5 md:p-6 bg-background-50 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-1.5">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{cat.description}</p>
              <p className="mt-3 text-xs text-accent-500 font-medium">{cat.count} 部作品</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}